import { Component, Inject } from '@angular/core';
import { LockUnlockListItemsActionComponent } from '@app/components';
import { DokumentacijaHierarhijaComponent } from '@app/components/dokumentacija/dokumentacija-hierarhija.component';
import { TreeViewProviderDirective } from '@app/providers';
import {
  ActionResult,
  DataSource,
  ListView,
  ListViewProviderDirective,
  NotificationService
} from '@ntap/core';
import { Observable, tap } from 'rxjs';

@Component({
  selector: 'app-lock-unlock-dok-list-items-action',
  templateUrl:
    '../lock-unlock-list-items-action/lock-unlock-list-items-action.component.html'
})
export class LockUnlockDokumentacijaListItemsActionComponent extends LockUnlockListItemsActionComponent {
  constructor(
    protected override notificationService: NotificationService,
    protected override dataSource: DataSource,
    protected override listViewProvider: ListViewProviderDirective<ListView>,
    @Inject(DokumentacijaHierarhijaComponent)
    private treeComponent: DokumentacijaHierarhijaComponent
  ) {
    super(notificationService, dataSource, listViewProvider);
  }

  public override doExecute(): Observable<ActionResult> {
    return super.doExecute().pipe(
      tap(() => {
        if (this.listViewProvider instanceof TreeViewProviderDirective) {
          if (this.treeComponent?.childrenListViewProvider) {
            // reload child (desne) liste zbog propertyja (disabled) na akcijama koji stignu s getView pozivom
            this.treeComponent.childrenListViewProvider.reload();
          }
        }
      })
    );
  }
}
